import { useTranslation } from 'react-i18next';
import { Paragraph } from '@digdir/designsystemet-react';
import { ShieldLockIcon } from '@navikt/aksel-icons';
import classes from './ResultsFooter.module.css';

const TRUSTPULSE_URL = 'https://www.trustpulse.no';

export const ResultsFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className={classes.footer}>
      <div className={classes.inner}>
        <ShieldLockIcon aria-hidden className={classes.icon} />
        <Paragraph data-size="sm" className={classes.text}>
          {t('publicSurvey.footer.text')}{' '}
          <a href={TRUSTPULSE_URL} target="_blank" rel="noopener noreferrer" className="ds-link">
            {t('publicSurvey.footer.linkText')}
          </a>
        </Paragraph>
      </div>
    </footer>
  );
};
